<template>
<div>
<Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="chose-list" >
    <van-radio-group v-model="radio" @change="OnChange">
      <div v-for="(item, index) in list" :key="index">
        <van-radio :name="index">
          <div class="chose-item">
            <div class="chose-item-content">
              <div class="content-item">货主:{{item.ownername}}</div>
              <div class="goods-name">品名:{{item.goodsname}}</div>
            </div>
          </div>
        </van-radio>
      </div>
    </van-radio-group>
  </div>

  <div class="step-box">
    <div class="before-step" >
      <van-button round block type="primary"  class="beforeBtn" @click="backChose">
        重新选择
      </van-button>
    </div>
    <div class="after-step" >
      <van-button round block type="info" class="afterBtn" @click="yuyueGoods">
        确定
      </van-button>
    </div>
  </div>

  <van-popup v-model="showPicker" round position="bottom">
    <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" :loading="loading" />
  </van-popup>

</div>
</template>

<script>
import api from "@/fetch/api"
import Nav from "../Public/navTpl.vue"
import {
  Dialog,
  Toast,
} from 'vant';
export default {
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      yuyueList: [],
      list: [],
      choseDate:[],
      showPicker: false,
      showField: false,
      columns: [],
      value: '',
      loading: false,
      radio: 0,
    }
  },
  props: {

  },
  created() {
    var that = this;
    var openid = that.$store.state.wx_info.openid;
    var driverNo = that.$route.params.driverNo;
    var escortNo = that.$route.params.escortNo;
    var chetouhao = that.$route.params.chetouhao;
    var cheguahao = that.$route.params.cheguahao;
    var inputBillNo = that.$route.params.inputBillNo;
    that.getYuyueXhList(openid,chetouhao,cheguahao,driverNo,escortNo,inputBillNo);

  },
  methods: {
    getYuyueXhList(openid,chetouhao,cheguahao,driverNo,escortNo,inputBillNo){
      var that = this;
      api.getXhYuyueList(openid,chetouhao,cheguahao,driverNo,escortNo,inputBillNo).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var dataList = res.data;
          that.$data.list = dataList;
        } else if (res.respCode < 0) {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });
        } else {
          Toast.fail('连接异常');
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    yuyueGoods() {
      var that = this;
      var dataList = that.$data.list;
      var choseIndex = that.$data.choseDate
      //var tihuoList = [];
      var choseData = [];

      if(choseIndex.length == 0){
        choseData = dataList[0];
      }
      else{
        choseData = choseIndex;
      }

      //请确认是否提某某客户的什么品种，如以上信息均不是您需要选择的提货，请联系货主确认
      Dialog.confirm({
        message: '请确认卸货信息是否正确',
      }).then(() => {
        that.getPdInfo(choseData);
      }).catch(() => {
        // on cancel
        return false;
      });

    },
    backChose()
    {
      this.$router.go(-1);
    },
    OnChange(index) {
      var yuyueList = this.$data.list;
      this.$data.choseDate = yuyueList[index];
    },
    onConfirm(value) {
      this.showPicker = false;
      var id = value.id;
      //var text = value.text;
      var openid = this.$store.state.wx_info.openid;

      var that = this;

      api.addYuyue(openid, id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          Dialog.alert({
              message: '预约成功',
            })
            .then(() => {
              // on confirm
              that.$router.push({
                name: 'orderlist'
              });
            })
        } else if (res.respCode < 0) {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });
        } else {
          Dialog.alert({
            message: '连接异常',
          }).then(() => {

          });
        }

      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    getPdInfo(item) {
      var that = this;
      var openid = that.$store.state.wx_info.openid;

      // api.getPdInfoNew(item.receivecorp,item.goodsname,item.ship,item.receiptdescription,item.ownername,openid).then(function(resData) {
      api.getPdInfoNew2(item.checiid,item.checixh,item.receiptdescription,item.ownername,openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.showField = true;
          that.$data.showPicker = true;

          var dataList = res.data;
          var columns = [];
          for (var i = 0; i < dataList.length; i++) {
            columns.push({
              id: dataList[i]['id'],
              text: dataList[i]['pdrq'] + ' ' + dataList[i]['pdsj']
            });
            that.$data.columns = columns;
          }
        } else if (res.respCode < 0) {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });
        } else {
          Dialog.alert({
            message: '连接异常',
          }).then(() => {

          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },

  },
  watch: {
    active: {
      handler(val, oldValue) {
        console.log(oldValue);
        switch (val) {
          case 0:
            this.beforeShow = false;
            this.afterShow = true;
            this.finishShow = false;

            this.driverShow = true;
            this.escortShow = false;
            this.chetouShow = false;
            this.cheguaShow = false;
            break;
          case 1:
            this.beforeShow = true;
            this.afterShow = true;
            this.finishShow = false;

            this.driverShow = false;
            this.escortShow = true;
            this.chetouShow = false;
            this.cheguaShow = false;
            break;
          case 2:
            this.beforeShow = true;
            this.afterShow = true;
            this.finishShow = false;

            this.driverShow = false;
            this.escortShow = false;
            this.chetouShow = true;
            this.cheguaShow = false;
            break;
          case 3:
            this.beforeShow = true;
            this.afterShow = false;
            this.finishShow = true;

            this.driverShow = false;
            this.escortShow = false;
            this.chetouShow = false;
            this.cheguaShow = true;
            break;
        }
      },
      deep: true //true 深度监听
    }
  }
}
</script>
<style lang="scss" scoped>
.chose-list {
    margin-top: 3.5rem;
    .chose-item {
        margin: 1rem 0;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        width: 90%;
        .chose-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .chose-name {
              font-weight: bold;
              font-size: .875rem;
              line-height:3;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                // white-space: nowrap;
                // text-overflow: ellipsis;
            }
        }
        .chose-item-desc {
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
    }
}

.van-radio {
    margin-left: 1rem;
}

.step-box {
    position: fixed;
    bottom: 1rem;
    width: 100%;
    .before-step {
        display: inline-block;
        width: 50%;
        float: left;
        .beforeBtn {
            width: 80%;
            margin: 0 auto;
        }
    }

    .after-step {
        display: inline-block;
        width: 50%;
        float: right;
        .afterBtn {
            width: 80%;
            margin: 0 auto;
        }
    }
}
</style>
